import React from 'react';
import {Button, Glyphicon, Navbar, Table} from 'react-bootstrap';

import BaseComponent from 'components/base/base-component';
import AvailableDictionaryItemsSelect from "../../dialogs/available-dictionary-items-select";
import DeleteConflictOrphansDialog from "../../dialogs/delete-conflict-orphans";


const MODAL_MODE = {
	ADD: 0,
	EDIT: 1
};

class EventCategoriesTab
	extends BaseComponent {

	constructor(props) {

		super(props);

		this.state = {
			eventCategories: props.eventCategories ? props.eventCategories : [],
			selectedEventCategories: props.eventCategories ? props.eventCategories : [],
			selected: null,
			showModal: false,
			modalMode: null
		};
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.eventCategories !== this.props.eventCategories) {
			this.setState({
				              eventCategories: this.props.eventCategories ? this.props.eventCategories : [],
			              })
		}
	}

	componentDidCatch(error, errorInfo) {
		this.setState({
			              error: true
		              })
	}

	handleOnItemClick = (item) => {
		this.setState({selected: item.id});
	};

	addButtonHandler = () => {
		this.setState({
			              modalMode: MODAL_MODE.ADD,
			              showModal: true
		              });
	};

	handleOnSaveEventCategories = (eventCategories) => {
		if (this.state.modalMode === MODAL_MODE.ADD) {
			this.props.onAddCategories(eventCategories, (eventCategories) => {
				this.setState({
					              eventCategories: eventCategories,
					              modalMode: null,
					              showModal: false
				              });
			});
		}
	};

	render() {

		if (this.state.error) {
			return <div className="tab-content">Error occurred...</div>
		}

		return (
			<div className="tab-content">
				<Navbar fluid={true} bsClass="c-navbar navbar-default">
					<div className="tab-buttons-group">
						{
							this.props.hasSelectButton &&
							<Button bsClass="btn icon action-button" onClick={this.addButtonHandler}>
								<Glyphicon glyph="plus" className="c-glyph-icon"/>
								<div className="label-wrapper">
									<label>Select</label>
								</div>
							</Button>
						}
					</div>
				</Navbar>
				<div className="table-wrapper">
					<Table>
						<thead>
						<tr>
							<th>Name</th>
							<th>Description</th>
						</tr>
						</thead>
						<tbody>
						{
							this.state.eventCategories
							    .map(item => {
								    return (
									    <tr key={item.id}
									        className={this.state.selectedId && this.state.selectedId === item.id ? 'selected' : ''}>
										    <td>{item.title}</td>
										    <td>{item.description}</td>
									    </tr>
								    );
							    })
						}
						</tbody>
					</Table>
				</div>
				{
					<AvailableDictionaryItemsSelect show={this.state.showModal}
					                                onHide={() => this.setState({showModal: false})}
					                                title={"Event Categories"}
					                                items={this.props.availableEventCategories}
					                                selectedItems={this.state.eventCategories}
					                                onSave={this.handleOnSaveEventCategories}
					                                onSelectionChange={(items) => {
						                                this.setState({
							                                              selectedEventCategories: items
						                                              })
					                                }}
					/>
				}
				{
					this.props.orphans && this.props.orphans.length !== 0 &&
					<DeleteConflictOrphansDialog show={this.props.orphans && this.props.orphans.length !== 0}
					                             title={"Orphans"}
					                             items={this.props.orphans}
					                             selectedItem={this.props.selectedOrphan}
					                             itemInfoProvider={this.props.itemInfoProvider}
					                             onItemClicked={
						                             (item) => {
							                             this.props.selectOrphan(item);
						                             }
					                             }
					                             onHide={
						                             () => {
							                             this.props.clearOrphans();
						                             }
					                             }
					                             onProceed={
						                             (e) => {
							                             this.handleOnSaveEventCategories(this.state.selectedEventCategories)
						                             }
					                             }/>
				}
			</div>
		);
	}
}

export default EventCategoriesTab;
export {EventCategoriesTab};